/**
 * APT 상세 데이터 테이블 정렬 — 순수 함수
 * SPEC: docs/IPT-545-SPEC.md
 *
 * 규칙:
 * - result는 숫자(심각도 0~3) 기준 비교
 * - 그 외 컬럼은 문자열 localeCompare(한글/영문)
 * - 빈 값/null은 정렬 방향과 무관하게 항상 뒤로
 * - 원본 배열을 변형하지 않음(불변)
 */

export interface AptDetailRow {
  company: string;
  team: string | null;
  name: string;
  email: string;
  result: number;
  reportCategory?: string | null;
}

export type AptSortKey = keyof AptDetailRow;
export type SortDirection = 'asc' | 'desc';

const isEmpty = (v: unknown): boolean =>
  v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

export function sortAptRows(
  rows: AptDetailRow[],
  key: AptSortKey,
  direction: SortDirection,
): AptDetailRow[] {
  const dir = direction === 'asc' ? 1 : -1;

  return [...rows].sort((a, b) => {
    const av = a[key];
    const bv = b[key];

    // 빈 값/null은 방향과 무관하게 항상 뒤로
    const aEmpty = isEmpty(av);
    const bEmpty = isEmpty(bv);
    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1;
    if (bEmpty) return -1;

    // result(심각도)는 숫자 비교
    if (key === 'result') {
      return ((av as number) - (bv as number)) * dir;
    }

    // 그 외는 문자열 localeCompare (한국어 우선)
    return String(av).localeCompare(String(bv), 'ko') * dir;
  });
}
